import { useAppDispatch } from "../../hooks";
import React, { useEffect } from "react";
import { LOGIN_SUCCESS } from "../../actions/auth";
import { auth as diiaAuth } from "../../actions/diia";
import styles from "../../styles/Popup/Popup.module.css";
import { QRCodeSVG } from "qrcode.react";
import Popup from "./Popup";
import { CircularProgress } from "@mui/material";
import MediaQuery from "react-responsive";

export function DiiaLoginPopup(props: DiiaProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (props.diia.auth.state === "success") {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: props.diia.auth,
      });
    } else {

      const timer = setTimeout(() => {
        dispatch(diiaAuth(props.diia.requestId));
      }, 3000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [props.diia]);

  return (
    <Popup
      clickCloseButton={props.clickCloseButton}
    >
      <MediaQuery maxWidth={767}>
        <h2>Оберіть один із двох запропонованих варіантів</h2>
        <div className={styles.variant}>
          <div className={styles.numbers}>1</div>
          <h3>
            Натисніть кнопку <span>“Увійти”</span>, якщо Дія встановлена на
            цьому пристрої
          </h3>
        </div>
        <a
          className={styles.button}
          href={props.diia.deeplink}
          target="_blank"
          rel="noreferrer"
        >
          Увійти
        </a>
        <div className={styles.divider} />

        <div className={styles.variant}>
          <div className={styles.numbers}>2</div>
          <h3>
            Відкрийте Дію та натисніть на кнопку &nbsp;<span>“Дія Сканер”</span>
          </h3>
        </div>

        <div className={styles.qr} style={{marginBottom: 20}}>
          {props.diia.state === "loading" ? (
            <CircularProgress
              size={124}
              sx={{
                color: "var(--dark-gray)",
              }}
            />
          ) : (
            <>
              {props.diia.deeplink === undefined ? (
                <p>На жаль, не можливо згенерувати QR, спробуйте пізніше</p>
              ) : (
                <QRCodeSVG value={props.diia.deeplink} size="171" />
              )}
            </>
          )}
        </div>
      </MediaQuery>
      <MediaQuery minWidth={768}>
        <h1 style={{marginBottom: '20px'}}>Увійти через Дію</h1>
        <p>Відкрийте Дію та натисніть на кнопку &nbsp;&nbsp;
        <span>“Дія Сканер”</span> </p>
        <div className={styles.qr}>
          {props.diia.state === "loading" ? (
            <CircularProgress
              size={124}
              sx={{
                color: "var(--dark-gray)",
              }}
            />
          ) : ( 
            <>
              { !props.diia.deeplink === undefined ? (
                <p>На жаль, не можливо згенерувати QR, спробуйте пізніше</p>
              ) : (
              <QRCodeSVG value={props.diia.deeplink} size="256"  />
              )}
            </>
          )}
        </div>
      </MediaQuery>
    </Popup>
  );
}
